var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.imgshow || !_vm.src
    ? _c(
        "div",
        {
          ref: "imgdiv",
          staticClass: "img-ssr-vue-div flexCenter",
          style: _vm.style
        },
        [
          _vm.defaultSrc
            ? _c("img", {
                staticClass: "img-ssr-vueshowsrc1",
                attrs: { title: "", src: "defaultSrc", alt: "" }
              })
            : _c("img", {
                staticClass: "img-ssr-vueshowsrc1",
                attrs: { title: "", src: _vm.src1, alt: "" }
              })
        ]
      )
    : _c("div", { staticClass: "img-ssr-vue-div flexCenter" }, [
        _vm.src.indexOf(";base64,") != -1
          ? _c("img", {
              staticClass: "img-ssr-vueshowsrc",
              attrs: { title: "", src: _vm.src, alt: _vm.alt },
              on: { error: _vm.error }
            })
          : _vm.src.indexOf("blob:http:") != -1
          ? _c("img", {
              staticClass: "img-ssr-vueshowsrc",
              attrs: { title: "", src: _vm.src, alt: _vm.alt },
              on: { error: _vm.error }
            })
          : _vm.src.indexOf(".gooeto.com") == -1
          ? _c("img", {
              staticClass: "img-ssr-vueshowsrc",
              attrs: { title: "", src: _vm.src, alt: _vm.alt },
              on: { error: _vm.error }
            })
          : _c("img", {
              staticClass: "img-ssr-vueshowsrc",
              attrs: {
                title: "",
                src:
                  _vm.src +
                  "?mediaToken=" +
                  this.$store.state.userinfo.mediaToken
              },
              on: { error: _vm.error }
            })
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63944eef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63944eef","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueImg/VueImg.vue
// module id = 661
// module chunks = 25